import { render, staticRenderFns } from "./AppliedDocCountByDirection.vue?vue&type=template&id=289dfa2e&scoped=true&"
import script from "./AppliedDocCountByDirection.vue?vue&type=script&lang=js&"
export * from "./AppliedDocCountByDirection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289dfa2e",
  null
  
)

export default component.exports